var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6667 2.66659H12V1.33325H10.6667V2.66659H5.33333V1.33325H4V2.66659H3.33333C2.59333 2.66659 2 3.26659 2 3.99992V13.3333C2 14.0666 2.59333 14.6666 3.33333 14.6666H12.6667C13.4 14.6666 14 14.0666 14 13.3333V3.99992C14 3.26659 13.4 2.66659 12.6667 2.66659ZM12.6667 13.3333H3.33333V5.99992H12.6667V13.3333ZM4.33333 8.66659C4.33333 7.74659 5.08 6.99992 6 6.99992C6.92 6.99992 7.66667 7.74659 7.66667 8.66659C7.66667 9.58659 6.92 10.3333 6 10.3333C5.08 10.3333 4.33333 9.58659 4.33333 8.66659Z",
    fill: "inherit"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.8ad521d8d18f055407c035cc85fe68e4.svg";
export { ForwardRef as ReactComponent };